import { Header } from '@/components/header.tsx'
import { PermissionsProvider } from '@/components/permissions-provider.tsx'
import { eventsManager } from '@/utils/events-manager.ts'
import { Outlet, createFileRoute, useLocation, useRouter } from '@tanstack/react-router'
import { useCallback, useEffect } from 'react'

export const Route = createFileRoute('/_app')({
  component: AppLayout,
})

function AppLayout() {
  const router = useRouter()
  const location = useLocation()

  const invalidateRoutAndRedirect = useCallback(() => {
    router.invalidate({ sync: true }).finally(() => {
      void router.navigate({
        to: '/auth/sign-in',
        replace: true,
        search: {
          redirect: location.href,
        },
      })
    })
  }, [location])

  useEffect(() => {
    const removeEvent = eventsManager.on('auth:unauthenticated', invalidateRoutAndRedirect)

    return () => {
      removeEvent()
    }
  }, [])

  return (
    <PermissionsProvider>
      <div className="flex min-h-screen flex-col antialiased">
        <Header />
        <div className="flex flex-1 flex-col gap-4 p-8 pt-6">
          <Outlet />
        </div>
      </div>
    </PermissionsProvider>
  )
}
